<template>
    <div class="header-nav clearfix" :style="{height: getHeight+'px'}">
        <div class="header-nav_box">
            <div class="header-nav-inner">
                <div 
                    class="header-nav-list"
                    v-for="(v,i) in navList" 
                    :key="i"
                >
                    <div 
                        class="header-nav-list_link" 
                        v-for="k in v" 
                        :key="k.id"
                    >
                        <router-link 
                            class="header-nav-list_link-box" 
                            :class="{on: path == k.url}" 
                            :to="k.url" 
                            @click="closeNav"  
                        >
                            <span class="header-nav-list_link-text">{{k.name}}</span>
                            <span class="header-nav-list_link-line"></span>                    
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TheHeaderNav',
    props: {
        navOn: Boolean
    },
    data: function () {
        return {
            path: this.$route.path,
            navList: [
                [
                    {
                        id: 1,
                        url: "/",
                        name: "首页"
                    }
                ],
                [
                    {
                        id: 1,
                        url: "/example",
                        name: "案例"
                    },{
                        id: 2,
                        url: "/product",
                        name: "产品"
                    },{
                        id: 3,
                        url: "/method",
                        name: "方法"
                    },{
                        id: 4,
                        url: "/industry-experience",
                        name: "行业经验"
                    }

                ],
                [
                    {
                        id: 1,
                        url: "/aboutus",
                        name: "关于我们"
                    },{
                        id: 2,
                        url: "/service",
                        name: "我们的服务"
                    },{
                        id: 3,
                        url: "/contact-us",
                        name: "联系我们"
                    },
                ]
            ]
        }
    },
    computed: {
        getHeight: function(){
            let nh = 0;
            let h = document.documentElement.clientHeight || document.body.clientHeight;
            nh = this.navOn ? h : 0;
            return nh;
        }
    },
    methods: {
        closeNav: function (){
            // this.$emit('closeNav', data);
            this.$emit('closeNav');
        }
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*@media*/

</style>